<script setup lang="ts">
import type { Image } from "~/types/common";

interface SmallCardProps {
  slug?: string;
  title?: string;
  subTitle?: string;
  image?: Image;
}

const props = defineProps<SmallCardProps>();
</script>

<template>
  <div class="row align-items-center edu-small-card">
    <div class="col-6">
      <img
        :src="$getStrapiImageSrc(props.image)"
        class="img-fluid br-20 object-fit-cover m-auto d-block"
        style="height: 150px; width: 100%"
        :alt="props.title"
      />
    </div>
    <div class="col-6">
      <h4>
        <NuxtLinkLocale
          :to="`/education/${props.slug}`"
          class="text-left text-decoration-none text-body"
        >
          {{ props.title }}
        </NuxtLinkLocale>
      </h4>
    </div>
  </div>
</template>
